import { Show } from "solid-js";

import { usePlayer } from "~/components/PlayerContext";
import Image from "~/components/player/Image";
import SmartMarquee from "~/components/player/SmartMarquee";
import styles from "~/components/player/SongMetadata.module.scss";

export default function SongMetadata() {
  const player = usePlayer();
  const currentSong = () => player.metadata?.song_history[0];

  return (
    <div class={styles.wrapper}>
      <Image
        displayFallback
        class={styles.cover}
        sources={currentSong()?.cover ?? []}
        alt=""
      />
      <div class={styles.metadata}>
        <SmartMarquee>
          <b>{currentSong()?.title}</b>
        </SmartMarquee>
        <Show when={currentSong()?.artist}>
          <SmartMarquee>
            <span>{currentSong()?.artist}</span>
          </SmartMarquee>
        </Show>
        <Show when={currentSong()?.album}>
          <SmartMarquee>
            <cite>{currentSong()?.album}</cite>
          </SmartMarquee>
        </Show>
        <Show when={currentSong()?.requested_by}>
          <SmartMarquee>
            <small>
              (pedido de <b>{currentSong()?.requested_by}</b>)
            </small>
          </SmartMarquee>
        </Show>
      </div>
    </div>
  );
}
